import { createAsyncThunk } from "@reduxjs/toolkit";
import getApiUrl from "../../../api";

const asyncLogin = createAsyncThunk(
    'auth/login',
    async function({login, password}) {
        if (!login || !password) return {};

        let promise;
        try {
            promise = await fetch(getApiUrl() + '/api/auth/login', {
                method: "POST",
                body: JSON.stringify({login, password})
            })
            const json = await promise.json();

            return json;
        } catch (error) {
            console.log(error);
            return {
                data: {
                    success: false,
                    errors: "Непредвиденная ошибка!"
                }   
            }
        }
    }
)

export default asyncLogin;